
// Libraries
var React = require('react');

// Styles
require('./PlayersPlayer.scss');

// Assets
var defaultImg = require('./default.png');
var PlaceholderImg = require('images/blankImgPlaceholder.png');

class PlayersPlayer extends React.Component {
	componentDidMount() {
		const picturefill = require('picturefill');	
		picturefill();
	}
	
	render() {
		const images = this.props.playerImage;

		return (
			<a className="PlayersPlayer" href={this.props.url}>
				<div className="PlayersPlayer__photo">
					{this.props.playerImage === null ? (
						<img src={defaultImg} alt={"No photo for " + this.props.name} />
					) : (
						<img src={PlaceholderImg} data-src={images.smallUrl + '*,*' + images.mediumUrl + '*,*' + images.largeUrl + '*,*' + images.extraLargeUrl} alt={this.props.playerImage.altText} />
					)}
				</div>
				<div className="PlayersPlayer__underline"/>
				<div className="PlayersPlayer__info">
					<div className="PlayersPlayer__number">{this.props.playerNumber && this.props.playerNumber > 0 ? this.props.playerNumber : ""}</div>
					<div className="PlayersPlayer__name">{this.props.fullName}</div>
					{this.props.playerShowPosition &&
						<div className="PlayersPlayer__position">{this.props.playerPosition}</div>
					}
					<div className="PlayersPlayer__country">{this.props.playerPlaceOfBirth}</div>
				</div>
			</a>
		)
	}
}

module.exports = PlayersPlayer;



// WEBPACK FOOTER //
// ./src/components/Players/PlayersPlayer.js